import React, { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown } from "react-feather";
import CustomizerContext from "../../../_helper/Customizer";
import { getStoredUser } from "../../../api/auth";
import { LI, UL } from "../../../AbstractElements";
import BorrowerRegisterModal from "../../../Components/Credora/Borrowers/BorrowerRegisterModal";
import CollateralModal from "../../../Components/Credora/Borrowers/CollateralModal";
import GuarantorModal from "../../../Components/Credora/Borrowers/GuarantorModal";
import NewRestructuringModal from "../../../Components/Credora/Loans/NewRestructuringModal";
import { menuHref } from "../../Sidebar/Menu";
import { visibleQuickCreateActions } from "../headerQuickCreate";

const NewHeaderQuickCreate = () => {
  const { layoutURL } = useContext(CustomizerContext);
  const navigate = useNavigate();
  const user = getStoredUser();
  const actions = useMemo(() => visibleQuickCreateActions(user), [user]);

  const [borrowerOpen, setBorrowerOpen] = useState(false);
  const [guarantorOpen, setGuarantorOpen] = useState(false);
  const [collateralOpen, setCollateralOpen] = useState(false);
  const [restructuringOpen, setRestructuringOpen] = useState(false);

  if (!actions.length) {
    return null;
  }

  const openModal = (modal) => {
    if (modal === "borrower") setBorrowerOpen(true);
    if (modal === "guarantor") setGuarantorOpen(true);
    if (modal === "collateral") setCollateralOpen(true);
    if (modal === "restructuring") setRestructuringOpen(true);
  };

  const handleAction = (action) => {
    if (action.type === "navigate" && action.path) {
      navigate(menuHref(action.path, layoutURL));
      return;
    }
    if (action.type === "modal" && action.modal) {
      openModal(action.modal);
    }
  };

  return (
    <>
      <LI attrLI={{ className: "credora-new-header-item onhover-dropdown pe-0 py-0" }}>
        <button type="button" className="credora-new-header-btn">
          <span className="credora-new-header-btn__plus">+</span>
          <span>NEW</span>
          <ChevronDown size={16} className="credora-new-header-btn__chevron" />
        </button>
        <UL attrUL={{ className: "simple-list credora-new-header-menu onhover-show-div" }}>
          {actions.map((action) => (
            <LI key={action.id} attrLI={{ onClick: () => handleAction(action) }}>
              <span>{action.label}</span>
            </LI>
          ))}
        </UL>
      </LI>

      <BorrowerRegisterModal
        isOpen={borrowerOpen}
        toggle={() => setBorrowerOpen(false)}
        onCreated={() => setBorrowerOpen(false)}
      />
      <GuarantorModal isOpen={guarantorOpen} toggle={() => setGuarantorOpen(false)} onSaved={() => setGuarantorOpen(false)} />
      <CollateralModal isOpen={collateralOpen} toggle={() => setCollateralOpen(false)} onSaved={() => setCollateralOpen(false)} />
      <NewRestructuringModal
        isOpen={restructuringOpen}
        toggle={() => setRestructuringOpen(false)}
        onCreated={() => setRestructuringOpen(false)}
      />
    </>
  );
};

export default NewHeaderQuickCreate;
